module.exports = __webpack_public_path__ + "static/media/Mshaikh1.c0aec857.png";